export default {
  checkout: 'Checkout',
};
